module.exports = __webpack_public_path__ + "media/07.b2ac05e2.mp4";